import { GET_STATES } from "../actions/ActionTypes";

const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function StateReducer(state = initialState, actions) {
  if (actions.type === GET_STATES) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_STATES
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { StateReducer };
